<div class="my-compliments-component-container">
  <ng-template #gotoLink>
    <app-action-link [href]="complimentsWallUrl" [target]="'blank'">
      <span>See more compliments</span><i class="ml-2 ms-Icon ms-Icon--ArrowUpRight" aria-hidden="true"></i>
    </app-action-link>
  </ng-template>

  <div class="d-none d-md-block float-md-right mt-1">
    <ng-container *ngTemplateOutlet="gotoLink"></ng-container>
  </div>
  <h2 class="widget-header h4 my-news-title">Celebrating excellence</h2>
  <span class="text-muted">Read the compliments we have received about our practice and our people, and compliments from our partners.</span>
  <div class="d-block d-md-none mt-2 mt-md-0">
    <ng-container *ngTemplateOutlet="gotoLink"></ng-container>
  </div>

  <div class="compliments-item-container">
    <div *ngIf="personalComplimentItems$ | async as personalComplimentItems; else innerLoading">
      <div *ngIf="personalComplimentItems && personalComplimentItems.length > 0">
        <app-news-card-list [personalNewsItems]='personalComplimentItems'></app-news-card-list>
      </div>

      <div *ngIf="personalComplimentItems && personalComplimentItems.length === 0">
        <app-text-placeholder>
          <p>No compliments could be found according to your channel selections.</p>
        </app-text-placeholder>
      </div>

      <div *ngIf="loading" class="mt-4">
        <div *ngIf="errorSubject$ | async as err; else innerLoading">
          <app-error-templates [error]="err.status"></app-error-templates>
        </div>
      </div>
    </div>
  </div>

  <ng-template #innerLoading>
    <div class="mt-4">
      <app-widget-placeholder></app-widget-placeholder>
    </div>
  </ng-template>

  <div class="row justify-content-center mt-4" *ngIf="fetchedAmountOfPosts > amountOfComplimentPostsToDisplayCurrently && !loading && numberOfShowMoreClicks < maxNumberOfShowMore else linkToComplimentsCenter">
    <div class="col-auto">
      <button mat-flat-button color="accent" class="blog-show-more-btn" (click)="showMoreComplimentPosts()"><span>Show more</span><i class="ml-2 ms-Icon ms-Icon--ChevronDown" aria-hidden="true"></i></button>
    </div>
  </div>

  <ng-template #linkToComplimentsCenter>
    <div class="col-auto mt-4 text-center" *ngIf="!loading">
      <span>For older compliments, <app-action-link [href]="complimentsWallUrl" [target]="'blank'">Click here</app-action-link></span>
    </div>
  </ng-template>
</div>
